export default {
	firstName: "Nombre",
	lastName: "Apellido",
	nickname: "Apodo",
	email: "Correo",
	name: "Nombre",
	birthDate: "Fecha de Nacimiento",
	firstVisitDate: "Primera Visita",
	gender: "Género",
	cpf: "CPF",
	rg: "RG",
	maritalStatus: "Estado Civil",
	type: "Tipo",
	phone: "Teléfono",
	mobile: "Celular",
	whatsappOptIn: "Acepta recibir avisos por WhatsApp",
	whatsappOptInHint: "La persona autoriza recibir cobros y avisos del templo por WhatsApp, enviados desde el número oficial del ORI (consentimiento LGPD)",
	address: "Dirección",
	street: "Calle",
	addressNumber: "Número",
	addressComplement: "Complemento",
	neighborhood: "Barrio",
	city: "Ciudad",
	state: "Estado (UF)",
	zipCode: "Código postal",
	zipCodeNotFound: "Código postal no encontrado",
	zipCodeLookupFailed: "No se pudo consultar el código postal ahora — completa la dirección a mano",
	paiDeCabeca: "Padre de Cabeza",
	maeDeCabeca: "Madre de Cabeza",
	fatherName: "Nombre del Padre",
	motherName: "Nombre de la Madre",
	nationality: "Nacionalidad",
	occupation: "Profesión",
	emergencyContactName: "Contacto de Emergencia",
	emergencyContactPhone: "Teléfono de Emergencia",
	bloodType: "Tipo de Sangre",
	healthNotes: "Salud y Medicación",
	healthNotesHint:
		"Problemas de salud, alergias y medicación de uso continuo. Dato sensible según la LGPD — solo los dirigentes lo ven y lo editan.",
	healthAdminOnly: "Solo los dirigentes ven los datos de salud",
	imageUseConsent: "Autoriza el uso de imagen",
	imageUseConsentHint:
		"La persona autoriza al templo a usar su imagen en fotos y videos (consentimiento LGPD)",
	imageUseConsentSince: "Autorizado el {date}",
	notes: "Observaciones",
	sections: {
		personal: "Datos",
		address: "Dirección",
		family: "Familia",
		emergency: "Contacto de emergencia",
		health: "Salud",
		consents: "Autorizaciones",
		permissions: "Permisos",
		spiritual: "Espiritual",
	},
	fullRegistration: "Registro completo",
	tabs: {
		basic: "Información Básica",
		functions: "Funciones",
		guides: "Guías",
		journey: "Viaje Mediúmnico",
	},
	types: {
		medium: "Médium",
		assistencia: "Asistencia",
	},
	// Claves iguales a los valores del enum de Prisma — la etiqueta sale de
	// `people.genders[person.gender]`, sin tabla de conversión en el medio.
	genders: {
		MALE: "Masculino",
		FEMALE: "Femenino",
		OTHER: "Otro",
	},
	maritalStatuses: {
		SINGLE: "Soltero(a)",
		MARRIED: "Casado(a)",
		STABLE_UNION: "Unión libre",
		DIVORCED: "Divorciado(a)",
		WIDOWED: "Viudo(a)",
	},
	edit: "Editar Persona",
	create: "Crear Persona",
	messages: {
		invalidForm: "Revise los campos destacados antes de guardar",
		loading: "Cargando persona...",
		loadError: "Error al cargar persona",
		created: "{name} fue creado(a) con éxito",
		updated: "{name} fue actualizado(a) con éxito",
		deleted: "{name} fue eliminado(a) con éxito",
		createError: "Error al crear persona",
		updateError: "Error al actualizar persona",
		deleteError: "Error al eliminar persona",
	},
	mediums: {
		searchPlaceholder: "Buscar médium...",
		filters: {
			all: "Todos",
			journeyStage: "Etapa del Viaje",
			orixa: "Orixá",
			function: "Función",
		},
		newMedium: "Nuevo Médium",
		table: {
			code: "Código",
			name: "Nombre",
			journey: "Viaje",
			orixas: "Orixás",
			function: "Función",
			contact: "Contacto",
		},
		tooltips: {
			view: "Ver Perfil",
			edit: "Editar",
			journey: "Gestionar Viaje",
		},
		empty: {
			title: "Ningún médium encontrado",
			description: "Intente ajustar los filtros o incluya un nuevo médium en la corriente",
		},
		stats: {
			total: "Total",
			active: "Activos",
		},
	},
	photo: {
		addPhoto: "Toque para agregar foto",
		capture: "Capturar",
		closeCamera: "Cerrar cámara",
		dragHere: "Arrastre una imagen o haga clic para seleccionar",
		maxSize: "Tamaño máximo: {size}MB",
		retake: "Tomar Otra",
		tabFile: "Archivo",
		tabWebcam: "Webcam",
		upload: "Actualizar Foto",
		uploadError: "Error al actualizar foto",
		uploadSuccess: "Foto actualizada con éxito",
		webcamError: "No fue posible acceder a la cámara",
	},
	roleHistory: {
		loadError: "Error al cargar historial de la etapa",
	},
	consultants: {
		searchPlaceholder: "Buscar consultante...",
		filters: {
			all: "Todos",
			withTickets: "Con Fichas",
			withReturn: "Con Retorno",
			recent: "Recientes",
		},
		newConsultant: "Nuevo Consultante",
		table: {
			code: "Código",
			name: "Nombre",
			lastVisit: "Última Visita",
			contact: "Contacto",
			visits: "Atenc.",
			birthday: "Cumpleaños",
			registration: "Registro",
			status: "Estado",
		},
		neverAttended: "Nunca atendido",
		ticket: "ficha",
		tickets: "fichas",
		return: "Retorno",
		tooltips: {
			newTicket: "Nueva Ficha",
			alreadyHasTicket: "El consulente ya tiene una ficha activa en este ritual",
			history: "Historial",
			edit: "Editar",
		},
		empty: {
			title: "Ningún consultante encontrado",
			description: "Intente ajustar los filtros o registre un nuevo consultante",
		},
		stats: {
			total: "Total",
			withTickets: "Con Fichas",
			returns: "Retornos",
		},
	},
	archive: {
		dialogTitle: "Archivar Persona",
		archiveAction: "Archivar",
		unarchiveAction: "Desarchivar",
		blockedByFinancialHistory: "Esta persona tiene movimientos financieros y no puede eliminarse — su historial forma parte de la rendición de cuentas. Archívela: sale de las listas, los cobros pendientes se cancelan y todo el rastro se conserva. Se puede desarchivar después.",
		blockedByMandate: "Esta persona tiene débito automático ACTIVO. Cancélelo antes, o el cobro seguirá ocurriendo en el proveedor de pago aunque la ficha salga de las listas.",
		reasonLabel: "Motivo del archivo (opcional)",
		reasonPlaceholder: "Ej.: se mudó de ciudad, se alejó de la casa",
		archived: "{name} fue archivada.",
		unarchived: "{name} volvió a las listas.",
		error: "No fue posible completar el archivo.",
		banner: "Persona archivada por {user} el {date}. No aparece en las listas del día a día.",
		filterLabel: "Archivadas",
	},
	deleteDialog: {
		title: "Eliminar Persona Permanentemente",
		warning: "Esta acción es irreversible y eliminará permanentemente todos los datos relacionados con esta persona:",
		items: {
			journeyHistory: "Historial de viaje y jerarquía",
			tickets: "Fichas de atención",
			messages: "Mensajes y observaciones",
			returns: "Retornos",
			guides: "Vínculos con guías",
			functions: "Funciones asignadas",
			financial: "Suscripciones y movimientos financieros",
		},
		impactTitle: "Lo que esta persona tiene hoy:",
		impact: {
			openCharges: "Cobros pendientes",
			paidMovements: "Pagos registrados",
			subscriptions: "Inscripciones activas",
			tickets: "Fichas de atención",
			messages: "Mensajes",
			nothing: "Nada registrado — la ficha puede eliminarse sin pérdida.",
		},
		codeInstruction: "Para confirmar, escriba el código a continuación:",
		codePlaceholder: "Escriba el código de confirmación",
		codeError: "Código incorrecto",
		deleting: "Eliminando...",
	},
	mergeDialog: {
		menuLabel: "Duplicado",
		title: "Fusionar persona en otra",
		warning: "Esta acción es irreversible. Todos los vínculos de \"{name}\" (recorrido, fichas, mensajes, retornos, guías, funciones, financiero) se moverán a la persona seleccionada y \"{name}\" será eliminada.",
		description: "Seleccione la persona que recibirá todo el historial:",
		destinationLabel: "Persona destino",
		destinationHint: "La persona que se quedará con todos los vínculos de la actual",
		sameAsSourceError: "La persona destino no puede ser la misma que la origen",
		codeInstruction: "Para confirmar, escriba el código a continuación:",
		codePlaceholder: "Escriba el código de confirmación",
		codeError: "Código incorrecto",
		confirm: "Fusionar y eliminar",
		merging: "Fusionando...",
		successMessage: "{source} se fusionó con éxito en {destination}",
		errorMessage: "Error al fusionar personas",
	},
};
